import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { trackPageView } from './util/tracking';

import asyncComponent from "./asyncComponent";

import HomePage from './pages/Home';
import CodeIndex from './pages/Code/Code';
import ContactPage from './pages/Contact';


/*
import Mars00Preamble from './pages/blog/Mars/Mars_00_Preamble';
import Mars01Situation from './pages/blog/Mars/Mars_01_Situation';
import Mars02Proposals from './pages/blog/Mars/Mars_02_Proposals';
import Mars03UTC from './pages/blog/Mars/Mars_03_UTC';
import Mars04Optimisations from './pages/blog/Mars/Mars_04_Optimisations';
import Mars05Solar from './pages/blog/Mars/Mars_05_Solar';
import Mars06Universal from './pages/blog/Mars/Mars_06_Universal';
import Mars07Synodic from './pages/blog/Mars/Mars_07_Synodic';
import Mars08Planets from './pages/blog/Mars/Mars_08_Planets';
import Mars09GregorianProblems from './pages/blog/Mars/Mars_09_GregorianProblems';
import Mars10GregorianImprovements from './pages/blog/Mars/Mars_10_GregorianImprovements';
import Mars11GregorianTransition from './pages/blog/Mars/Mars_11_GregorianTransition';
import MapResearch from './pages/blog/MapResearch/-Maps_index';
*/

/*
import Space from './pages/blog/Space';
import Probate from './pages/blog/Probate';
import Curves from './pages/blog/Curves';
import Omaha from './pages/Cards/Omaha';
import HoldEm from './pages/Cards/HoldEm';
import TorusUpgrade from './pages/blog/TorusUpgrade';
import PocketOddsLaunched from './pages/blog/PocketOddsLaunched';
import PocketOddsIphone from './pages/blog/PocketOddsIphone';
import PerfectPokerCoinTosses from './pages/blog/PerfectPokerCoinTosses';

import DemosTorus from './pages/Demos/Torus';
import DemosCanvascape from './pages/Demos/Canvascape';
*/
import "bootstrap/dist/css/bootstrap.css";

import './App.css';

export const RedirectToCode = () => <b>Redirect</b>;

export const Todo = () => <b>Todo</b>;

const MarsPdf = asyncComponent(() =>
  import("./pages/blog/Mars/Mars_Pdf/Mars_Pdf")
);

/*
const MarsOverview = asyncComponent(() =>
  import("./pages/blog/Mars/MarsOverview")
);
*/

const FastDate = asyncComponent(() =>
  import("./pages/blog/FastDate/FastDate")
);
const SafeDate = asyncComponent(() =>
  import("./pages/blog/FastDate/SafeDate")
);
const FastDate64 = asyncComponent(() =>
  import("./pages/blog/FastDate/FastDate64")
);
const FastLeapYear = asyncComponent(() =>
  import("./pages/blog/FastDate/FastLeapYear")
);
const FastWeekday = asyncComponent(() =>
  import("./pages/blog/FastDate/FastWeekday")
);
const FastOrdinalDate = asyncComponent(() =>
  import("./pages/blog/FastDate/FastOrdinalDate")
);
const FastDateRefined = asyncComponent(() =>
  import("./pages/blog/FastDate/FastDateRefined")
);
const Vinted = asyncComponent(() =>
  import("./pages/blog/Vinted")
);
const Map = asyncComponent(() =>
  import("./pages/blog/Map/MapIndex")
);
/*
const FastHebrewDate = asyncComponent(() =>
  import("./pages/blog/FastDate/FastHebrewDate")
);
*/
const FastTime = asyncComponent(() =>
  import("./pages/blog/FastDate/FastTime")
);
/*
const FastTimestamp = asyncComponent(() =>
  import("./pages/blog/FastDate/FastTimestamp")
);
*/

const Page404 = () => {
  return <div>
    <h1>404 - Page not found</h1>
  </div>
}

(function (history) {
  
  const pushState = history.pushState;

  history.pushState = function (state, something, url) {
    const ret = pushState.apply(history, arguments);
    trackPageView(url);

    const hasHash = url.indexOf("#") >= 0;

    if (!hasHash) {
      window.scrollTo(0, 0);
      return ret;
    }

    if (hasHash) {
      setTimeout(() => {
        const encodedName = encodeURIComponent(url.substr(url.indexOf("#") + 1));
        if (encodedName.indexOf("%") < 0 && encodedName.indexOf('=') < 0) {
          const ele =
            window.document.getElementById(encodedName) ||
            window.document.body.querySelector("a[name=" + encodedName + "]");

          if (ele) {
            ele.scrollIntoView();
            return;
          }
        }
        window.scrollTo(0, 0);
      }, 1);
    }

    return ret;
  };
})(window.history);

export default class App extends Component {
  render() {
    return (
      <Router>
        <Routes>
          <Route exact path="/" element={<HomePage />} />
          <Route exact path="/code" element={<CodeIndex />} />
          <Route exact path="/contact" element={<ContactPage />} />

          <Route exact path="/vinted" element={<Vinted />} />

          {/*
          <Route exact path="/mars-time" element={<MarsOverview />} />
          */}
          
          <Route exact path="/smoitus" element={<MarsPdf />} />
          <Route exact path="/fast-date" element={<FastDate />} />
          <Route exact path="/safe-date" element={<SafeDate />} />
          <Route exact path="/fast-date-64" element={<FastDate64 />} />
          <Route exact path="/fast-leap-year" element={<FastLeapYear />} />
          <Route exact path="/fast-day-of-week" element={<FastWeekday />} />
          <Route exact path="/fast-time-of-day" element={<FastTime />} />
          {/*<Route exact path="/fast-timestamp" element={<FastTimestamp />} />*/}
          <Route exact path="/fast-ordinal-date" element={<FastOrdinalDate />} />
          <Route exact path="/fast-date-refined" element={<FastDateRefined />} />
          {/*<Route exact path="/fast-date/faster" element={<FastDateFaster />} />*/}
          {/*<Route exact path="/fast-hebrew-date" element={<FastHebrewDate />} />*/}
          
          <Route exact path="/map" element={<Map />} />
          
          {/*
          <Route path="/omaha" element={<Omaha />} />
          <Route path="/holdem/*" element={<HoldEm />} />
          <Route path="/torus_upgrade" element={<TorusUpgrade />} />
          <Route path="/PocketOdds_Launched" element={<PocketOddsLaunched />} />
          <Route path="/Pocket-Odds-iPhone" element={<PocketOddsIphone />} />
          <Route path="/Perfect_Poker_Coin_Tosses" element={<PerfectPokerCoinTosses />} />
          <Route path="/space" element={<Space />} />
          <Route path="/probate" element={<Probate />} />
          <Route path="/curves" element={<Curves />} />
          */}

          {/*
          <Route exact path="/map-test" element={<MapResearch />} />
          <Route exact path="/mars" element={<Mars00Preamble />} />
          <Route exact path="/mars/situation" element={<Mars01Situation />} />
          <Route exact path="/mars/proposals" element={<Mars02Proposals />} />
          <Route exact path="/mars/utc" element={<Mars03UTC />} />
          <Route exact path="/mars/optimisations" element={<Mars04Optimisations />} />
          <Route exact path="/mars/solar" element={<Mars05Solar />} />
          <Route exact path="/mars/universal" element={<Mars06Universal />} />
          <Route exact path="/mars/synodic" element={<Mars07Synodic />} />
          <Route exact path="/mars/planets" element={<Mars08Planets />} />
          <Route exact path="/mars/gregorian-problems" element={<Mars09GregorianProblems />} />
          <Route exact path="/mars/gregorian-improvements" element={<Mars10GregorianImprovements />} />
          <Route exact path="/mars/gregorian-transition" element={<Mars11GregorianTransition />} />
          */}

          {/*

          <Route exact path="/code/demos" element={<RedirectToCode />} />
          <Route exact path="/code/games" element={<RedirectToCode />} />
          <Route exact path="/code/toys" element={<RedirectToCode />} />
          <Route exact path="/code/tools" element={<RedirectToCode />} />
          <Route exact path="/code/projects" element={<RedirectToCode />} />
          <Route exact path="/code/dev" element={<RedirectToCode />} />

          <Route path="/code/games/torus" element={<DemosTorus />} />
          <Route path="/code/tools/functions3d" element={<Todo />} />
          <Route path="/code/tools/functions3d/keywords" element={<Todo />} />
          <Route path="/code/tools/functions3d/examples" element={<Todo />} />
          <Route path="/code/demos/canvascape" element={<DemosCanvascape />} />
          <Route path="/code/demos/canvascape/textures']" element={<Todo />} />
          <Route path="/code/toys/spirograph" element={<Todo />} />
          <Route path="/code/tools/colours" element={<Todo />} />
          <Route path="/code/games/snake" element={<Todo />} />
          <Route path="/code/games/pipepanic" element={<Todo />} />
          <Route path="/code/games/ninjamaze" element={<Todo />} />
          <Route path="/code/demos/collide" element={<Todo />} />
          <Route path="/code/demos/arc" element={<Todo />} />
          <Route path="/code/demos/interpolate" element={<Todo />} />
          <Route path="/code/projects/syntax" element={<Todo />} />
          */}

          <Route path="*" element={<Page404 />} />

        </Routes>
      </Router>
    );
  }
};
